import React, { useContext, useEffect, Fragment } from "react";
import { useParams } from "react-router-dom";
import {
  Segment,
  Grid,
  Image,
  Container,
} from "semantic-ui-react";
import { IAcceptRejectInvoice } from "../../../../app/models/trackDocument";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import { observer } from "mobx-react-lite";
import LoadingComponent from "../../../../app/layout/LoadingComponent";

document.title = "Majim-e Detalle de Documento Electrónico";


const AcceptRejectInvoiceByEmail: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { getRejectionConceptsByEmail } = rootStore.listOfValours;
  const {
    acceptRejectDocument,
    getDocumentInfo,
    loadByEmail,
  } = rootStore.invoiceStore;

  const { invoice } = useParams();


  const x = atob(invoice);
  const doc: IAcceptRejectInvoice = JSON.parse(x);
  useEffect(() => {
    getRejectionConceptsByEmail(doc.token);
    getDocumentInfo(doc.id, doc.token);
  }, [getRejectionConceptsByEmail, getDocumentInfo, doc.id, doc.token]);

  return (
    <div className="divuserview">
      <Segment padded="very" textAlign="center" className="segmentuserview ">
        {!loadByEmail ? (
          <LoadingComponent content="Cargando" />
        ) : (
          <Fragment>
            <Container textAlign="left">
                <table className="enterpriseTitleTable">
                  <tr>
                    <td className="enterpriseLogoTd"><Image
                      src={
                        "data:image/png;base64," + acceptRejectDocument.supplierlogo
                      }
                      size="tiny"
                      verticalAlign="bottom"
                    />{" "}</td>
                    <td className="enterpriseTitleTd"><span>
                      <strong>{acceptRejectDocument.suppliername}</strong>
                    </span></td>
                  </tr>
                </table>
            </Container>
            
            <p>
              A través de esta opción puedes aceptar o rechazar la factura de
              venta. En caso de rechazo debes seleccionar el motivo. Recuerda
              que pasados 3 días a partir de la fecha de la factura se dará por
              aceptada.
            </p>
            <Segment attached placeholder className="invoiceInfoDiv" >
              <div className="qrimagecontainer">
                   <Image className="qrimageclient"
                      src={
                        "data:image/png;base64," + acceptRejectDocument.qrData
                      }
                      verticalAlign="bottom"
                    />
              </div>
              <Grid columns={2} textAlign="center">
                <Grid.Row>
                  <Grid.Column className="labelstyle">
                    <p>Factura No. </p>
                  </Grid.Column>
                  <Grid.Column className="infostyle">
                    <strong>{acceptRejectDocument.docId}</strong>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column className="labelstyle">
                    <p>A nombre de </p>
                  </Grid.Column>
                  <Grid.Column className="infostylesort">
                    <strong>{acceptRejectDocument.acquirerName}</strong>
                  </Grid.Column>
                  <Grid.Column className="lateralstyle">     
                    &nbsp;               
                  </Grid.Column>     
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column className="labelstyle">
                    <p>Fecha Factura </p>
                  </Grid.Column>
                  <Grid.Column className="infostyle">
                    <strong>{acceptRejectDocument.issueDate}</strong>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column className="labelstyle">
                    <p>Identificación </p>
                  </Grid.Column>
                  <Grid.Column className="infostyle">
                    <strong>
                      {acceptRejectDocument.acquirerIdentification}
                    </strong>
                  </Grid.Column>                       
                </Grid.Row>                
                <Grid.Row>
                  <Grid.Column className="labelstyle">
                    <p>Por valor de </p>
                  </Grid.Column>
                  <Grid.Column className="infostyle">
                    <strong>{acceptRejectDocument.formatedValue}</strong>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column className="labelstyle">
                    <p>CUFE </p>
                  </Grid.Column>
                  <Grid.Column className="infostyle">
                    <strong>{acceptRejectDocument.cufe}</strong>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
              <div className="divCopyrigth">
                <p className="pCopyright">
                  Documento electrónico emitido desde Majim-e
                </p>
                <p className="pCopyright">
                &copy; 2020 Majim-e. Todos los derechos reservados. <a className="aCopyright" target="_blank" href='https://www.majim-e.co'>www.majim-e.co</a>
                </p>
            </div>
          </Fragment>
        )}
      </Segment>
    </div>
  );
};

export default observer(AcceptRejectInvoiceByEmail);
